import { ActivateRandomDream } from "source/app/presentation/MainPanel/Dreams/DreamHelpers/DreamHelpers";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import {
    GetVisibleGoalCardIds,
    HighlightRandomGoalCard,
} from "source/app/presentation/MainPanel/Goals/GoalsFloatingTools/GoalsFloatingTools";
import { HighlightRandomMonumentalLogEntry } from "source/app/presentation/MainPanel/LogMonumental/FloatingTools/logMonumentalFloatingTools";
import { ActivateRandomNode } from "source/app/presentation/MainPanel/Workflows/RootNodeName/WorkflowsFloatingTools/WorkflowsFloatingTools";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import { IActivePanelState } from "source/app/presentation/Shared/ActivePanel/IActivePanelState";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { RandomizeSurvivalGuideSlider } from "../../../../../presentation/RadialSurvivalGuide/Slider/DrawSlider";

export function HandleSelectRandomItemHotkey() {
    const activePanel = State.ReadClass<IActivePanelState>(
        ESharedComponent.ActivePanel
    );

    if (!activePanel) {
        return;
    }

    const { activePanelId } = activePanel.state;

    if (activePanelId === EPanelId.Workflows) {
        const workflows = GetWorkflowsState();

        if (workflows !== undefined) {
            const { rootNode } = workflows.state;

            if (!rootNode.viewchronological) {
                ActivateRandomNode(rootNode);
            }
        }
    }

    if (activePanelId === EPanelId.Dreams) {
        const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

        if (dreams !== undefined) {
            ActivateRandomDream();
        }
    }

    if (activePanelId === EPanelId.Habits) {
        const visibleGoalCardIds = GetVisibleGoalCardIds();
        HighlightRandomGoalCard(visibleGoalCardIds);
    }

    if (activePanelId === EPanelId.LogMonumental) {
        HighlightRandomMonumentalLogEntry();
    }

    if (activePanelId === EPanelId.Hero) {
        RandomizeSurvivalGuideSlider();
    }
}
